

<div class="table-responsive design-table">
    <table class="table table-hover table-striped">
        <thead>
            <tr>
                <th>Approval Level</th>
                <th>Approver Name</th>
                <th>Status</th>               
                <th>Activity Date</th>   
                <th>Remark</th>               
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let activity of ApproverLogData">
                <td style="padding-left:40px;">{{activity.ApprovalLevel}}</td>
                <td style="padding-left:10px;">{{activity.ApproverName}}</td>
                <td style="padding-left:10px;"><span>{{activity.Status}}</span></td>
                <td style="padding-left:10px;" >
                    {{activity.ActivityDate | dateTimeFormat}}
                </td>
                <td style="padding-left:10px;max-width:500px">{{activity.Remark}}</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="ApproverLogData?.length === 0" class="no-record-found">No Records Found</div>
   
</div>
<div style="margin-top : 20px;">
<span *ngFor="let approval of ApprovalsList">
<p style="background-color: aqua;"><b>{{approval.LevelText}}</b>{{approval.ApprovalList}}</p>
</span>
</div>
